module.exports = __webpack_public_path__ + "static/media/swc.8c8bdba5.svg";